import * as yup from "yup";
import i18next from "i18next";

const t = (key: string) => i18next.t(key, { ns: "admin" }) as string;

export const validationSchemaPrice = yup.object().shape({
    orderTypeItemId: yup
    .string()
    .required(() => t("pricing.validation.orderTypeItemRequired"))
});